//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Countdown',
  props: {
    date: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      timer: null,
      showTimer: true,
      countTime: [{
        name: 'days',
        value: ''
      }, {
        name: 'hours',
        value: ''
      }, {
        name: 'minutes',
        value: ''
      }, {
        name: 'seconds',
        value: ''
      }]
    };
  },

  mounted() {
    this.countdown(this.date);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    countdown(value) {
      var dateEnd = new Date(value).getTime();
      this.timer = setInterval(() => {
        var dateStart = new Date().getTime();
        var timeRemaining = parseInt((dateEnd - dateStart) / 1000, 10);

        if (timeRemaining >= 0) {
          var days = parseInt(timeRemaining / 86400, 10);
          timeRemaining %= 86400;
          var hours = parseInt(timeRemaining / 3600, 10);
          timeRemaining %= 3600;
          var minutes = parseInt(timeRemaining / 60, 10);
          timeRemaining %= 60;
          var seconds = parseInt(timeRemaining, 10);
          this.countTime[0].value = "0".concat(days).slice(-2);
          this.countTime[1].value = "0".concat(hours).slice(-2);
          this.countTime[2].value = "0".concat(minutes).slice(-2);
          this.countTime[3].value = "0".concat(seconds).slice(-2);
        } else {
          this.showTimer = false;
          clearInterval(this.timer);
        }
      }, 1000);
    }

  }
};